
import { defineComponent, computed } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  setup() {
    const i18n = useI18n();
    const lang = computed(() => {
      return i18n.locale.value;
    });
    return {
      lang,
    };
  },
});
